import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user3",
  "use": "icon-user3-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-user3\"><defs><style></style></defs><title>个人中心</title><path class=\"cls-1\" d=\"M15,15.48A6.89,6.89,0,0,0,10.1,9a4.32,4.32,0,1,0-3.72.14C2,10,1.23,14,1,15.42c.07.36.22.58.58.58h13a.47.47,0,0,0,.43-.43v-.06h0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol